import React, { Component } from "react";
import {
  PaymentWrapper,
  ContentConatiner,
  ContentTitle,
  ContentCircle,
  RefuntOrCancle
} from "./Payment.style";
import {
  HeaderConatiner,
  HeaderIcon,
  HeaderText
} from "../../Common/Header/Header.style";
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
// import ReactGA from 'react-ga';
// import ReactPixel from 'react-facebook-pixel';
export class Payment extends Component {
  renderPaymentMode = () => {
    const { paymentMode, pointTicket, value } = this.props

    let productName
    let expiredDate
    if (paymentMode && paymentMode.product && paymentMode.product.productName) {
        productName = paymentMode.product.productName[value] || paymentMode.product.productName['en']
        expiredDate = paymentMode.expiredDate
    }
    else if (pointTicket && pointTicket.productName) {
        productName = `[POINT] ${pointTicket.productName[value] || pointTicket.productName['en']}`
        expiredDate = pointTicket.expiredDate
    }

    if (!productName || !expiredDate) return <ContentTitle>{i18n.t("payment.coupon.nopayment.text")}</ContentTitle>

    return <>
      <ContentCircle>
        <img src="https://front.videomonster.com/images-u6yd72dy/web/paymentCardImg.png" alt="이미지"></img>
      </ContentCircle>
      <ContentTitle>{this.props.date} {i18n.t("payment.current.paymentinfo.common.text")}<br /><span>{productName}</span> {i18n.t("payment.current.paymentinfo.subscribe1_2")} {`(~${new Date(expiredDate).toISOString().substr(2, 8).replace(/-/gi, '.')})`}</ContentTitle>
    </>
  }

  render() {
    const { paymentMode } = this.props

    return (
      <PaymentWrapper>
        <HeaderConatiner>
          <HeaderIcon src="https://front.videomonster.com/images-u6yd72dy/web/paymentIcon.png" />
          <HeaderText>{i18n.t("payment.name")}</HeaderText>
        </HeaderConatiner>
        <ContentConatiner>
          {this.renderPaymentMode(paymentMode)}
        </ContentConatiner>
      </PaymentWrapper>
    );
  }
}

Payment.propTypes = {
  date: PropTypes.number,
}
Payment.defaultProps = {
  date: 20190218
}